import axios from 'axios';
import { CREATE_STEP } from '../paths';

export const createStep = async (data) => {
  const { properties, points, exam, courseID, examLength } = data;
  const body = {
    courseID,
    title: properties?.title,
    type: properties?.type.value,
    stepTime: properties?.stepTime * 1 || undefined,
    mediaHash: properties?.type.value === 2 || properties?.type.value === 1 ? properties?.content : undefined,
    mediaDescription: properties?.description,
    html: properties?.type.value === 3 ? properties?.html : undefined,
    slideHashes: properties?.type.value === 0 ? properties?.slideHashes : undefined,
    score: points?.reward,
    passScore: points?.required,
    examLength: examLength,
    questions: exam.map((q, index) => {
      return { number: index + 1, title: q.title, options: q.options, answer: q.answer };
    }),
    medias: properties?.medias?.map(({ name, fileName, hash, type }) => ({
      name,
      fileName,
      hash,
      type: type?.type,
    })),
  };
  const response = await axios.post(CREATE_STEP, body);
  return response;
};
